import {
  PREPAID_ORDER_INVALID_AMOUNT_ERROR_MESSAGE,
  PREPAID_BOOKING_INVALID_AMOUNT_ERROR_MESSAGE,
} from './constants';

export const getPrepaidInvalidAmountMessage = (flag) =>
  flag > 0
    ? PREPAID_BOOKING_INVALID_AMOUNT_ERROR_MESSAGE
    : PREPAID_ORDER_INVALID_AMOUNT_ERROR_MESSAGE;
